import { useNavigate, Navigate, Link } from 'react-router-dom';
import { Button, HottrLockup, HottrOrb } from '@/kit';
import { routes } from '@/config/routes';
import { useMeStore } from '@/store/meStore';
import { useAuth } from '@/auth/AuthProvider';

export function LandingPage() {
  const navigate = useNavigate();
  const onboarded = useMeStore((s) => s.profile?.onboardingComplete);
  const { user } = useAuth();
  if (onboarded) return <Navigate to={routes.today} replace />;

  return (
    <div className="relative min-h-screen overflow-hidden bg-hottr-ink text-white">
      <div className="mx-auto flex min-h-screen max-w-3xl flex-col justify-between px-5 py-10 md:px-8">
        <header className="flex items-center justify-between gap-4">
          <HottrLockup product="me" size="md" showIcon={false} />
          {user ? (
            <span className="truncate text-[11px] text-white/48">{user.email}</span>
          ) : (
            <Link
              to={routes.auth}
              className="text-[11px] font-extrabold uppercase tracking-hottr-label text-hottr-pink hover:underline"
            >
              Sign in
            </Link>
          )}
        </header>

        <section className="flex flex-1 flex-col items-start justify-center gap-8 py-12">
          <div className="flex items-center gap-4">
            <HottrOrb size={56} state="resting" level="living" product="me" />
            <p className="text-[11px] font-extrabold uppercase tracking-hottr-stamp text-hottr-pink">
              Agency first
            </p>
          </div>

          <h1 className="max-w-xl font-display text-4xl font-black uppercase leading-[0.95] tracking-hottr-display md:text-5xl">
            Whatever&apos;s got you stuck
            <span className="text-hottr-pink">,</span>
            <br />
            start moving again
            <span className="text-hottr-pink">.</span>
          </h1>

          <p className="max-w-md text-[15px] leading-relaxed text-white/72">
            Practical help for loops you want to change — apps, habits, isolation, chems,
            confidence. No labels. No shame. No generic wellness. Your life. Your rules.
          </p>

          <div className="w-full max-w-sm">
            <Button variant="primary" size="lg" fullWidth onClick={() => navigate(routes.onboarding)}>
              Start
            </Button>
          </div>
        </section>

        <footer className="text-[11px] text-white/32">
          Part of the HOTTR ecosystem · Not therapy · Not treatment
        </footer>
      </div>
    </div>
  );
}
